import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormMeetingSignIn } from "../Models/Forms/IFormMeetingSignIn";
import { BaseService } from './BaseService';

@Injectable()
export class FormMeetingSignInService extends BaseService {

  _baseUrl: string = "";
  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {

    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormMeetingSignIn(id: number) {
    return this._http.get(this._baseUrl + "api/FormMeetingSignIn/" + id)
      .map((response: IFormMeetingSignIn) => response as IFormMeetingSignIn)
      .catch(this.errorHandler);
  }

  insertUpdateFormMeetingSignIn(formMeetingSignInDetails: IFormMeetingSignIn) {
    return this._http.post(this._baseUrl + 'api/FormMeetingSignIn', formMeetingSignInDetails)
      .map((response: IFormMeetingSignIn) => response as IFormMeetingSignIn)
      .catch(this.errorHandler);
  }

  deleteMeetingSignIn(id) {
    return this._http.delete(this._baseUrl + "api/FormMeetingSignIn" + id)
      .map((response: IFormMeetingSignIn) => response as IFormMeetingSignIn)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}




